<template>
  <div class="spinner">
    <div class="bounce1"></div>
    <div class="bounce2"></div>
    <div class="bounce3"></div>
  </div>
</template>

<script>
export default {}
</script>
<style lang="scss" scoped>
.spinner > div {
  width: 14px;
  height: 14px;
  background-color: var(--sub-color);
  border-radius: 100%;
  display: inline-block;
  margin: 3px;
  animation: bouncy 1.4s infinite cubic-bezier(0.46, 0.03, 0.52, 0.96) both;
}

.spinner .bounce1 {
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  animation-delay: -0.16s;
}

@keyframes bouncy {
  0%,
  100% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
}
</style>
